import PropTypes from 'prop-types'
import React, {
  createContext,
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
  useCallback,
} from 'react'
import socketio from 'socket.io-client'
import api from '../services/api'

const GlobalContext = createContext({})

export const useGlobalContext = () => {
  return useContext(GlobalContext)
}

export const GlobalContextProvider = ({ children }) => {
  const socketRef = useRef(null)
  const showWebphoneRef = useRef(() => {})

  const [globalState, globalDispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'SET_DATA':
          return { ...state, ...action.payload }
        default:
          return state
      }
    },
    {
      tickets: [],
      ticketIndex: null,
      callcenterBreaks: [],
      inCallCenterBreak: false,
      callCenterBreakCod: null,
      callCenterBreakStart: null,
      callCenterLogin: false,
      callCenterBreakConfig: [],
      dominio: null,
      user_basix: null,
      tickets_filters: {
        visualizacao: 'todos',
        visualizacaoUser: 'todos',
        selectqtdContatos: '20',
        currentPage: 1,
        totalCount: 0,
        totalPages: 0,
        proto: '',
        de: '',
        para: '',
        cpf: '',
        startDate: '',
        endDate: '',
      },
    },
  )
  const stateRef = useRef(globalState)

  const { dominio, user_basix } = globalState

  const fetchOpenTickets = useCallback(async () => {
    try {
      const response = await api.get('/tickets/open')
      globalDispatch({
        type: 'SET_DATA',
        payload: {
          tickets: response.data,
        },
      })
    } catch (error) {
      console.error('Error ao obter tickets:', error)
    }
  }, [])

  useEffect(() => {
    const userWebsocket = localStorage.getItem('contact-user-websocket')
    const domainioWebsocket = localStorage.getItem('contact-dominio-websocket')

    globalDispatch({
      type: 'SET_DATA',
      payload: {
        dominio: domainioWebsocket,
        user_basix: userWebsocket,
      },
    })
  }, [])

  useEffect(() => {
    stateRef.current = globalState
  }, [globalState])

  useEffect(() => {
    if (!dominio || !user_basix) {
      if (socketRef.current) {
        socketRef.current.disconnect()
        socketRef.current = null
      }

      return
    }

    if (!socketRef.current) {
      // const tempSocket = socketio('https://devweb.cloudcom.com.br')
      const tempSocket = socketio('https://contact.cloudcom.com.br', {
        transports: ['websocket'],
        path: '/api/socket.io',
      })
      socketRef.current = tempSocket

      tempSocket.on(`${dominio}-${user_basix}-reload`, (data) => {
        fetchOpenTickets()
      })

      tempSocket.on(`${dominio}-${user_basix}`, (data) => {
        showWebphoneRef.current()

        globalDispatch({
          type: 'SET_DATA',
          payload: {
            tickets: [...stateRef.current.tickets, data], // Usa o estado mais recente
            ticketIndex: 0,
          },
        })
      })

      tempSocket.connect()
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect()
        socketRef.current = null
      }
    }
  }, [dominio, user_basix, fetchOpenTickets])

  return (
    <GlobalContext.Provider
      value={{ globalState, globalDispatch, showWebphoneRef }}
    >
      {children}
    </GlobalContext.Provider>
  )
}

GlobalContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
}
